<template>
  <div class="detail-container">
    <div class="detail-card-wrapper" :style="hasError && { height: '100%' }">
      <coupon-with-cart-card
        v-if="coupon"
        ref="card"
        :coupon="coupon"
        :index="0"
        :display-from="screenTypeDetail"
        :detail-button-label="detailButtonLabel"
        @show-usage-dialog="({ content, isHtmlDisplay }) => showUsageDialog({ content, isHtmlDisplay })"
        @card-loaded="cardLoaded"
        @tap-detail-button="showCouponList"
      />
      <coupon-with-cart-dialog
        key="usageDialog"
        ref="usageDialog"
        :in-detail="true"
        negative-button-label="閉じる"
        @negative="closeUsageDialog"
      />
      <template v-if="hasError">
        <error-popup
          :title="error.title"
          :message="error.message"
          :label="'閉じる'"
          @submit="clearError"
          @close="clearError"
        />
      </template>
    </div>
  </div>
</template>

<script>
import DateFormatter from '@/utils/DateFormatter'
import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'
import { mapActions } from 'vuex'
import CouponWithCartCard from '@/views/CouponWithCart/Card.vue'
import { SCREEN_TYPE } from '@/store/couponWithCart'
import CouponWithCartDialog from '@/views/CouponWithCart/Dialog.vue'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'

export default {
  name: 'CouponWithCartDetail',
  components: { ErrorPopup, CouponWithCartDialog, CouponWithCartCard },
  data() {
    return {
      apiTypeCouponDetail: '4',
      coupon: null,
      error: {},
      screenTypeDetail: SCREEN_TYPE.detail
    }
  },
  async created() {
    document.documentElement.style.backgroundColor = 'transparent'
    document.body.style.backgroundColor = 'transparent'
    const tmpId = this.$route.params.id.split(':')
    const couponId = tmpId[0]
    await this.fetchCouponOnDetail(couponId)
  },
  computed: {
    detailButtonLabel() {
      return this.coupon.data.status === '3' ? 'スタンプをためて特典をもらおう！' : 'ご利用は一覧から'
    },
    hasError() {
      return Object.keys(this.error).length > 1
    }
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Native', [
      'actionCallCloseCoupon',
      'actionRequestToken',
      'actionAdjustCouponHeight',
      'actionRequestExternalLink'
    ]),
    async fetchCouponOnDetail(id) {
      const accTime = new DateFormatter().format(new Date())

      const fetchCoupon = async ({ token, accTime, userId, couponId }) => {
        this.actionToggleLoading(true)
        const res = await APIClient.getCouponDetails(token, accTime, userId, couponId)

        const success = res &&
          res.data &&
          res.data.data &&
          res.data.data.code === ErrorCode.CODE_SUCCESS &&
          res.data.data.coupon_data &&
          res.data.data.coupon_data.coupons
        if (success) {
          this.coupon = res.data.data.coupon_data.coupons
        } else {
          this.error = {
            title: res && res.data && res.data.data && res.data.data.code ?
              `エラー ${res.data.data.code}` :
              `エラー ${ErrorCode.CODE_ERROR_NETWORK}`,
            message: res && res.data && res.data.data && res.data.data.message ?
              res.data.data.message :
              ErrorMessage.MSG_ERROR_NETWORK
          }
          this.actionToggleLoading(false)
        }
      }

      window.receivedToken = async (payload) => {
        const json = JSON.parse(payload)
        await fetchCoupon({
          token: json.app_token,
          accTime,
          userId: json.user_id,
          couponId: id
        })
      }
      this.actionRequestToken({ apiType: this.apiTypeCouponDetail, acc_time: accTime, coupon_id: id })

      // FIXME: for development
      // await fetchCoupon({ token: 'a', accTime, userId: '74dbff7edd0b559a', couponId: id })
    },
    showUsageDialog({ content, isHtmlDisplay }) {
      this.$refs.usageDialog.show({
        title: '利用条件',
        content,
        isHtmlDisplay
      })
    },
    closeUsageDialog() {
      this.$refs.usageDialog.close()
    },
    async cardLoaded() {
      const card = this.$refs.card.$refs['cardContainer-0']
      if (card) {
        await this.actionAdjustCouponHeight(card.clientHeight)
      }
      this.actionToggleLoading(false)
    },
    showCouponList() {
      this.actionCallCloseCoupon()
      const host = this.coupon.data.prize_type === '0' ? 'coupon' : 'freepass'
      this.actionRequestExternalLink(`frbbscreen://${host}`)
    },
    clearError() {
      this.error = {}
      this.actionCallCloseCoupon()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;

  &:disabled {
    opacity: 0.4;
  }
}

::v-deep .fade-enter-active, ::v-deep .fade-leave-active {
  transition: opacity 0.2s;
}
::v-deep .fade-enter, ::v-deep .fade-leave-to {
  opacity: 0;
}

::v-deep .card-container {
  margin-bottom: 0;
}

.detail-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .detail-card-wrapper {
    width: 100%;
    overflow: hidden;
    transform: scale(1);
    border-radius: 8px;
    display: flex;
    align-items: center;
  }
}
</style>
